import { createSlice } from '@reduxjs/toolkit'
import initialState from "./initialState";
import reducers from "./reducers";
import {liquidGetProduct, liquidRefreshProduct} from "./thunks";
import { defaultProduct } from "./defaultProduct";

function fetchProductReducer(state, action) {
  const product = action?.payload.products?.[0];
  const status = action?.payload?.status;
  state.oos = action?.payload.products?.length === 0
  if (status === 1 && product) {
    state.oos = false
    state.info = { ...product }
    if (product?.sizes?.length > 0) {
      state.selection = product.sizes[0]
      state.oosWithInfo = false
      state.oos = false
    } else {
      state.oosWithInfo = true
    }
  } else if (state.info.id !== defaultProduct.id) {
    state.oosWithInfo = true;
  } else {
    state.oos = true
  }
  state.loading = false;
}

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(liquidRefreshProduct.fulfilled, fetchProductReducer)
      .addCase(liquidGetProduct.fulfilled, fetchProductReducer)
      .addCase(liquidGetProduct.pending, (state) => {
        state.loading = true;
        state.oos = false;
        state.oosWithInfo = false;
      })
      .addCase(liquidGetProduct.rejected, (state) => {
        state.loading = false
      })
  }
})

export const {
  setLoading,
  setInfo,
  setQuantity,
  setSelection,
  setSeeMore,
  setImageSlider,
  setOss,
  setOosWithInfo,
  setEngraving,
  setBundle,
} = productSlice.actions

export function resetEngraving() {
  return setEngraving({
    active: false,
    msg: {
      line1: '',
      line2: '',
      line3: '',
    }
  })
}
export default productSlice.reducer
